import React from 'react';
import buildClassName from 'js/utils/classNameBuilder.util';

import style from './WarningMessage.scss';

export const WarningMessage = ({ classNames = {}, className = '', warning }) =>
    <div className={`${buildClassName(['warning'], style, classNames)} ${className}`}>
        {warning}
    </div>;
